<div class='app-alert {{divClass}}' *ngIf="showAlert" >          
            <span class="{{iconClass}}"></span>           
            <div class="{{iconTitleClass}}" >          
              {{iconTitleText}}
            </div>   
            <div class='{{bodyClass}}'>{{message}}</div>
</div> 
